module.exports = __webpack_public_path__ + "legacy-software-modernization.13nZGB1b.svg";